import { GridColDef } from "@mui/x-data-grid";
import { getValue } from "../../../utils/object.utils";

export const StudentResultTitle: GridColDef[] = [
  {
    field: "subject_name",
    headerName: "Subject",
    width: 180,
    editable: false,
    headerAlign: "center",
  },
  {
    field: "marks",
    headerName: "Marks",
    type: "number",
    width: 100,
    align: "left",
    headerAlign: "center",
    cellClassName: (params) => {
      const fullMarks = getValue(params, "row.full_marks", 0);
      return params.value > fullMarks ? "error-cell" : "";
    },
    editable: true,
  },
  {
    field: "grade",
    headerName: "Grade",
    // type: "string",
    type: "singleSelect",
    valueOptions: ["A+", "A", "B+", "B", "C+", "C", "D+", "D", "E"],
    width: 100,
    editable: true,
    headerAlign: "center",
    renderCell: (params) => params.value,
  },
  {
    field: "full_marks",
    headerName: "Full marks",
    type: "string",
    width: 150,
    editable: false,
    headerAlign: "center",
  },
];
